import React, { HTMLAttributes } from 'react';

import { Container } from './styles';

const LoadingDots: React.FC<HTMLAttributes<HTMLDivElement>> = () => {
  return (
    <Container>
      <div className="dot-flashing" />
    </Container>
  );
};

export default LoadingDots;
